<div *ngIf="isOfflineMode" (click)="openOfflineModal()" class="offline-mode">
  Нет сети 
</div>
